import { render } from "./art-direction.vue?vue&type=template&id=5c48e479"
import script from "./art-direction.vue?vue&type=script&lang=js"
export * from "./art-direction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__